import { render } from "./MessageDetailPage.vue?vue&type=template&id=62606a58&scoped=true"
import script from "./MessageDetailPage.vue?vue&type=script&lang=js"
export * from "./MessageDetailPage.vue?vue&type=script&lang=js"

import "./MessageDetailPage.vue?vue&type=style&index=0&id=62606a58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62606a58"]])

export default __exports__